import _ from 'lodash'

// See https://gist.github.com/LeverOne/1308368
export const uuidv4 = (a, b) => {
  for (b = a = ''; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '-');
  return b
}

export const joinHumanList = (values, separator) => {
  return _.join(_.filter(values), separator || ', ')
}

export const extractRouteName = (route) => {
  return _.isString(route) ? route : route.name || (route.meta && route.meta.root)
}

export const isRouteMatch = (first, second) => {
  return first === second || extractRouteName(first) === extractRouteName(second)
}
